import React from "react"

export default () => {
  return (
    <svg
      width="63px"
      height="100px"
      viewBox="0 0 63 100"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="tumblr">
        <g id="Group">
          <g id="Group">
            <path
              d="M49.3875 83.7C46.6125 83.7 44.0125 83.05 41.8625 81.7375C40.1438 80.7375 38.6313 79.0375 38.0313 77.4187C37.4313 75.7688 37.4938 72.3938 37.4938 66.6188L37.4938 43.7188L62.5125 43.7188L62.5125 25.0063L37.4938 25.0063L37.4938 0L21.375 0C20.725 5.14375 19.5563 9.4125 17.8375 12.7125C16.1938 16.075 13.8813 18.9187 11.15 21.325C8.325 23.7062 3.95 25.525 0 26.8187L0 40.9875L13.4187 40.9875L13.4187 76.0313C13.4187 80.625 13.8812 84.1313 14.8687 86.525C15.8375 88.9375 17.4937 91.2062 20.025 93.3312C22.5125 95.4812 25.4875 97.1312 29.0437 98.2937C32.5062 99.4375 35.2312 100 39.8125 100C43.8312 100 47.5875 99.6188 51.025 98.775C54.4688 97.9938 58.2125 96.8063 62.5125 94.8L62.5125 79.7688C57.4875 83.05 54.4562 83.7 49.3875 83.7L49.3875 83.7Z"
              id="Shape"
              fill="#000000"
              stroke="none"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
